import { render, staticRenderFns } from "./tenantSetup.vue?vue&type=template&id=ac2050ce&scoped=true&"
import script from "./tenantSetup.vue?vue&type=script&lang=js&"
export * from "./tenantSetup.vue?vue&type=script&lang=js&"
import style0 from "./tenantSetup.vue?vue&type=style&index=0&id=ac2050ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2050ce",
  null
  
)

export default component.exports